// extracted by mini-css-extract-plugin
export var partnerDetailsBlock = "index-module--partnerDetailsBlock--kUQ57";
export var partnerDetailsContainer = "index-module--partnerDetailsContainer--Lww2G";
export var partnerDetailsContent = "index-module--partnerDetailsContent--+oDBQ";
export var partnerDetailsItem = "index-module--partnerDetailsItem--KCwLU";
export var partnerDetailsLogo = "index-module--partnerDetailsLogo--8z8-P";
export var partnerDetailsLogoWrapper = "index-module--partnerDetailsLogoWrapper--6WHjE";
export var partnerDetailsWebsite = "index-module--partnerDetailsWebsite--6PVLN";